module.exports = "/assets/data/6c48732f7a4443b5d07701a76e6fcf8b-SY3.data.json";